export const SIGN_IN_PATH = "/sign-in";
export const SIGN_UP_PATH = "/sign-up";
export const FORGET_PASSWORD_PATH = "/forget-password";

export const ASK_QUESTION_PATH = "/ask";
export const DEFAULT_PATH = "/";
